import { PROVIDER_ROLE, GENERAL_ROLE } from '../../../constants/chat';

export const INTRO_HINT_SELECTORS = {
  common: {
    logout: 'intro-logout',
  },
  messages: {
    searchChat: 'intro-searchChat',
    selectChat: 'intro-selectChat',
    selectChannel: 'intro-selectChannel',
    generalChannel: 'intro-circleOfCareChannelName-tab',
    providerChannel: 'intro-providersChannelName-tab',
    familyChannel: 'intro-familyMembersChannelName-tab',
    typeFilter: 'intro-typeFilter',
  },

  patient: {
    circles: {
      inviteMember: `intro-inviteMember-${GENERAL_ROLE}`,
      cardActions: `intro-cardActions-${GENERAL_ROLE}`,
    },
    messages: {
      familyChat: 'intro-familyMembersChannelName-tab',
      providerChat: 'intro-providersChannelName-tab',
      generalChat: 'intro-circleOfCareChannelName-tab',
      typeMessage: 'intro-typeMessage',
      answerSurvey: 'intro-answerSurvey',
      patientName: 'intro-patientName',
      patientContext: 'intro-patientContext',
      patientProgram: 'intro-patientProgram',
    },
  },
  provider: {
    messages: {
      programFilter: 'intro-programFilter',
    },
    circles: {
      inviteMember: `intro-inviteMember-${PROVIDER_ROLE}`,
      cardActions: `intro-cardActions-${PROVIDER_ROLE}`,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/common/Intro/index.jsx